import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SERVICE_CENTER_PHONE_DISPLAY, SERVICE_CENTER_PHONE_TEL } from '../../../../../constants/phoneNumbers'
import './index.scss'

export const Footer = () => {
  const { t } = useTranslation()
  return (
    <footer>
      <div className='footer-content wrapper'>
        <div className='group'>
          <div className='item'>
            <div>
              <Link to='/imprint' role='link'>{t('FOOTER.IMPRINT')}</Link>
              <Link to='/privacy-policy' role='link'>{t('FOOTER.PRIVACY_POLICY')}</Link>
            </div>
          </div>
          <div>
            <div className='item'>
              <h3 role='heading'>{t('FOOTER.IMPORTANT_PHONE_NUMBERS')}</h3>
              <div>
                <div className='info-item-wrap'>
                  <span>{t('FOOTER.SERVICE_CENTER')}: </span>
                  <Link to={`tel:${SERVICE_CENTER_PHONE_TEL}`} role='link'>{SERVICE_CENTER_PHONE_DISPLAY}</Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className='item'>
              <h3 role='heading'>{t('FOOTER.HOMEPAGE_AROUNDTOWN')}</h3>
              <div>
                <div className='info-item-wrap'>
                  <Link
                    rel="noreferrer"
                    target='_blank'
                    to='https://www.aroundtown.de/'
                    role='link'
                  >
                    Home (aroundtown.de)
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className='item'>
              <h3 role='heading'>{t('FOOTER.HOMEPAGE_AROUNDTOWN_SERVICE')}</h3>
              <div>
                <div className='info-item-wrap'>
                  <Link
                    rel="noreferrer"
                    target='_blank'
                    to='https://aroundtown-service.de/de/'
                    role='link'
                  >
                    aroundtown-service.de
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className='item'>
              <h3 role='heading'>{t('FOOTER.HOMEPAGE_SNAPDESK')}</h3>
              <div>
                <div className='info-item-wrap'>
                  <Link
                    rel="noreferrer"
                    target='_blank'
                    to='https://thisisatworld.com/'
                    role='link'
                  >
                    Home (thisisatworld.com)
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
